module.exports = __webpack_public_path__ + "img/芒果5.5b8c9783.png";